import { render, staticRenderFns } from "./SimplifiedPaymentsList.vue?vue&type=template&id=4718b092&scoped=true"
import script from "./SimplifiedPaymentsList.vue?vue&type=script&lang=js"
export * from "./SimplifiedPaymentsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4718b092",
  null
  
)

export default component.exports